/* global $ */
// eslint-disable-next-line arrow-parens
export default options => {
  const jQuery = options.jQuery || $;
  return {
    get(callbackOk, callbackError, companyId) {
      jQuery.ajax({
        method: 'get',
        dataType: 'json',
        // Ensure this in all cases and jquery versions.
        accepts: { json: 'application/json' },
        headers: {
          Accept: 'application/json',
        },
        url: options.config.authHost + (companyId ? `?company_id=${companyId}` : ''),
        xhrFields: {
          withCredentials: true,
        },
        crossDomain: true,
        // eslint-disable-next-line arrow-parens
        success: response => {
          if (callbackOk) {
            callbackOk(response);
          }
        },
        // eslint-disable-next-line arrow-parens
        error: err => {
          if (callbackError) {
            callbackError(err);
          }
        },
      });
    },
  };
};



/** WEBPACK FOOTER **
 ** ./src/ticket.js
 **/